var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SourcingBoardView',{attrs:{"storage-key":"sourcingBoard","description":_vm.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }